module.exports = __webpack_public_path__ + "img/4-3.9fc2e4f5.svg";